import { AxiosResponse } from 'axios';
import { axiosRequest } from 'core/axios';
import { getHeaders } from 'core/common-methods';
import { PlanDTO } from 'core/plans/models';
import { createRequestAction, RequestAction } from 'core/utils/actionUtils';
import { Dispatch } from 'redux';
import { UUID } from '../../core/utils/BasicModels';

export const GET_PLAN_BY_ID: RequestAction = createRequestAction('GET_PLAN_BY_ID_REQUEST');

export const getPlanById =
  (planId?: UUID) => async (dispatch: Dispatch) => {
    try {
      dispatch({ type: GET_PLAN_BY_ID.REQUEST });
      const plans = await axiosRequest.get<any, AxiosResponse<PlanDTO>>(
        `/v2/plans/${planId}`,
        {
          headers: getHeaders().common,
        },
      );

      dispatch({ type: GET_PLAN_BY_ID.SUCCESS, payload: plans.data });
      return plans.data;
    } catch (e) {
      dispatch({ type: GET_PLAN_BY_ID.ERROR, payload: e });
      throw e;
    }
  };
